function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\u7F16\u7EC4");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "31.4465615%",
  y1: "4.37680102%",
  x2: "68.103157%",
  y2: "76.0419544%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD05E",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC131",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "C\\u7AEF",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu-cart",
  transform: "translate(-331.000000, -379.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-24"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-22",
  transform: "translate(16.000000, 343.500000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-21"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u52A0\\u51CF",
  transform: "translate(268.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  transform: "translate(47.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "add-circular-outlined-button",
  fill: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,0 C5.37223529,0 0,5.37223529 0,12 C0,18.6277647 5.37223529,24 12,24 C18.6277647,24 24,18.6269804 24,12 C24,5.37301961 18.6277647,0 12,0 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.5,11.25 L12.75,11.25 L12.75,7.5 C12.75,7.086 12.414,6.75 12,6.75 C11.586,6.75 11.25,7.086 11.25,7.5 L11.25,11.25 L7.5,11.25 C7.086,11.25 6.75,11.586 6.75,12 C6.75,12.414 7.086,12.75 7.5,12.75 L11.25,12.75 L11.25,16.5 C11.25,16.914 11.586,17.25 12,17.25 C12.414,17.25 12.75,16.914 12.75,16.5 L12.75,12.75 L16.5,12.75 C16.914,12.75 17.25,12.414 17.25,12 C17.25,11.586 16.914,11.25 16.5,11.25 Z",
  id: "Path",
  fillOpacity: 0.85,
  fill: "#000000"
})))))))));

const SvgAdd = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "25px",
  viewBox: "0 0 24 25",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add.70c15fa7.svg";
export { ForwardRef as ReactComponent };